import type { PitchFrame } from '@tunasong/plugin-lib'
import { hasFrameChoice } from '@tunasong/plugin-lib'
import type { PerformancePart } from '@tunasong/schemas'
import { ToggleButton, ToggleButtonGroup } from '@tunasong/ui-lib'
import type { FC } from 'react'
import styles from './pitch-frame-toggle.module.css'

export interface PitchFrameToggleProps {
  parts: readonly PerformancePart[]
  capo: number
  frame: PitchFrame
  onChange: (frame: PitchFrame) => void
}

const frames: { value: PitchFrame; label: string }[] = [
  { value: 'shapes', label: 'Shapes' },
  { value: 'concert', label: 'Concert' },
]

function isPitchFrame(value: unknown): value is PitchFrame {
  return value === 'shapes' || value === 'concert'
}

/**
 * Header "Shapes | Concert": one pitch frame for the whole screen (Bowie). Offered only with a capo and
 * Guitar among the parts; everywhere else the screen has one frame already. The choice is this song's.
 */
export const PitchFrameToggle: FC<PitchFrameToggleProps> = ({ parts, capo, frame, onChange }) => {
  if (!hasFrameChoice(parts, capo)) {
    return null
  }
  const handleChange = (_event: unknown, value: string | string[]) => {
    if (isPitchFrame(value) && value !== frame) {
      onChange(value)
    }
  }
  return (
    <ToggleButtonGroup aria-label="Pitch" value={frame} exclusive onChange={handleChange} className={styles.group}>
      {frames.map(({ value, label }) => (
        <ToggleButton key={value} value={value} className={styles.option}>
          {label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}

export default PitchFrameToggle
